import {Injectable} from '@angular/core';
import {DcpPriceData, DcpSubtotalGroups} from '@dcp/configurator';

@Injectable({
  providedIn: 'root'
})
export class DerivativePriceService {


  subtotalGroupPrice(priceData: DcpPriceData, key: string): DcpSubtotalGroups {
    return priceData?.price?.subtotalGroups?.find(s => s.code === key);
  }

  getTotalPrice(priceData: DcpPriceData) {
    return this.subtotalGroupPrice(priceData, 'all')?.formattedValues.totalValue;
  }

  getDerivativePrice(priceData: DcpPriceData) {
    return this.subtotalGroupPrice(priceData, 'derivatives')?.formattedValues.totalValue;
  }

  getDerivativeProductPrices(priceData: DcpPriceData) {
    return priceData?.price?.componentProducts;
  }
}
